<template>
  <div></div>
</template>
<script setup lang="ts">
definePageMeta({
  layout: false
})

const authStore = useAuthStore();
const route = useRoute();
const router = useRouter();
const { $getCookie } = useNuxtApp();

onMounted(async () => {  
  if (!route.query.code) {
    router.replace('/');
    return;
  }
  
  init();
});

const init = async (): Promise<void> => {
  const config = useRuntimeConfig();
  
  // access token 가져오기
  const accessToken = await getAcessTokenForKakao(`${route.query.code}`, `${checkURL()}/callbackKakao`);
  
  if (!accessToken) {
    router.replace('/');
    return;
  }
  
  snsLogin(accessToken);
};

const snsLogin = async (token: string): Promise<void> => {
  // 카카오 프로필 조회
  const result = await searchKakaoProfile(token);
  if (!result) {
    router.replace('/');
    return;
  }
  
  const kakaoUser = result.kakao_account;
  const snsUserInfo: SnsUserInfo = {
    snsID: token,
    name: kakaoUser.name,
    phoneNumber: kakaoUser.has_phone_number ? kakaoUser.phone_number.replace(/^[\+\-]\d+\s/, "0").replace(/-/g, "") : null,
    mailing: false,
    sms: false,
    appPush: false,
    route: 'kakao',
    nextUrl: `${route.query.state ?? ''}` ,
  };
  
  if (kakaoUser.birthyear && kakaoUser.birthday) snsUserInfo.birthDay = `${kakaoUser.birthyear}${kakaoUser.birthday}`;
  if (kakaoUser.gender) snsUserInfo.gender = kakaoUser.gender === 'male' ? 'M' : kakaoUser.gender === 'female' ? 'F' : 'U';
  if (kakaoUser.mobile) snsUserInfo.phoneNumber = kakaoUser.mobile;
  if (kakaoUser.ci) snsUserInfo.ci = kakaoUser.ci;
  if (kakaoUser.email) snsUserInfo.email = kakaoUser.email;
          
  authStore.setSnsToken({ route: 'kakao', accessToken: token });
  
  // SNS 약광 동의 정보 조회
  const terms = await getSNSUserTerms('kakao', token, false);

  console.log('sns약관동의 kakao::::::::::::::::::::', terms);
  
  snsUserInfo.mailing = terms.mailing;
  snsUserInfo.sms = terms.sms;
  snsUserInfo.appPush = terms.appPush;
  snsUserInfo.termsSeq = terms.termsSeq; 
  
  console.log('snsUserInfo', snsUserInfo);
          
  if (await loginSNS(snsUserInfo)) {
    let nextUrl = snsUserInfo.nextUrl ? snsUserInfo.nextUrl : ($getCookie('afterLoginUrl') ?? '/');
    
    if (!nextUrl) nextUrl = '/';
    
    replaceUrl(nextUrl);
  }
};
</script>